export enum MenuListActionTypes {
  UPDATE_MENU_LOADING = 'UPDATE_MENU_LOADING',
  FETCH_MENU_LIST_SAGA = "FETCH_MENU_LIST_SAGA",
  FETCH_MENU_LIST_SUCCESS = "FETCH_MENU_LIST_SUCCESS",
  CLEAR_MENU_LIST = "CLEAR_MENU_LIST",
  FETCH_MENU_UPDATE_PRICE_LIST_SAGA = "FETCH_MENU_UPDATE_PRICE_LIST_SAGA",
  FETCH_MENU_UPDATE_PRICE_LIST = "FETCH_MENU_UPDATE_PRICE_LIST",
  FETCH_MENU_UPDATE_PRICE_LIST_SUCCESS = "FETCH_MENU_UPDATE_PRICE_LIST_SUCCESS",
  FETCH_MENU_UPDATE_PRICE_LIST_ERROR = "FETCH_MENU_UPDATE_PRICE_LIST_ERROR",
  PUBLICATION_MENU_SAGA = "PUBLICATION_MENU_SAGA",
  DELETE_MENU_SAGA = "DELETE_MENU_SAGA",
  UPDATE_MENU_PRICE_LIST_SAGA = "UPDATE_MENU_PRICE_LIST_SAGA",

  OPEN_UPLOAD_MODAL = "OPEN_UPLOAD_MODAL",
  CLOSE_UPLOAD_MODAL = "CLOSE_UPLOAD_MODAL",

  UPDATE_MENU_SAGA = "UPDATE_MENU_SAGA",
  AUTO_UPDATE_MENU_SAGA = "AUTO_UPDATE_MENU_SAGA",

  FETCH_PUBLICATION_COUNT_SAGA = "FETCH_PUBLICATION_COUNT_SAGA",
  FETCH_PUBLICATION_COUNT_SUCCESS = "FETCH_PUBLICATION_COUNT_SUCCESS",

  CLOSE_PUBLICATION_COUNT_ALERT = "CLOSE_PUBLICATION_COUNT_ALERT",

  UPDATE_MOYSKLAD_MENU_SAGA = "UPDATE_MOYSKLAD_MENU_SAGA",

  RECOVERY_MENU_SAGA = "RECOVERY_MENU_SAGA",

  FETCH_JSON_FILE_SAGA = "FETCH_JSON_FILE_SAGA",
  UPLOAD_JSON_FILE_SAGA = "UPLOAD_JSON_FILE_SAGA",

  CREATE_POS_MENU_SAGA = "CREATE_POS_MENU_SAGA",

  REQUEST_YANDEX_PUBLICATION_SAGA = "REQUEST_YANDEX_PUBLICATION_SAGA",
}
